import moment from "moment";
import {Button, Datagrid, ExportButton, FunctionField, List, ShowButton, TextField, TopToolbar, useListContext } from "react-admin";
import { useAppSelector } from "../../store/hooks";
import ResourceSelectDialogButton from "../Common/ResourceSelectDialogButton";
import {useNavigate} from "react-router-dom";
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import FilterListOffIcon from "@mui/icons-material/FilterListOff";
import PhotoLibraryRoundedIcon from '@mui/icons-material/PhotoLibraryRounded';
import CommonFilterCard, { CommonFilterField } from "../Common/CommonFilterCard";
import StyledDatagridWrapper, { commonDatagridSx } from "../Common/StyledDatagridWrapper";


const ListActions = (props: any) => {
    const { setFilters } = useListContext();
    const resetFilter = () => {
      setFilters({}, [], false);
    };
    const navigate = useNavigate();

    return (
      <TopToolbar>
        <Button
          variant="text"
          size={"small"}
          onClick={resetFilter}
          startIcon={<FilterListOffIcon />}
          label="Clear filters"
        />
        <Button
          variant="text"
          size={"small"}
          onClick={()=>{
            navigate("/Cities/create")
          }}
          startIcon={<ControlPointIcon />}
          label="Create"
        />
        <Button
          variant="text"
          size={"small"}
          onClick={()=>{
            navigate("/banners")
          }}
          startIcon={<PhotoLibraryRoundedIcon/>}
          label="Show Banners"
        />
        <ExportButton/>
      </TopToolbar>
    );
};

const filterFields: CommonFilterField[] = [
    { type: "text", label: "City Name", source: "name" },
    {
        type: "select",
        label: "Serviceable",
        source: "isCurrentlyServing",
        options: ['YES','NO'].map((key) => ({
            value: key,
            label: key,
        })),
    },
];

export const CityList = () => {
    const isCustomSelectOpen = useAppSelector((state) => state.customSelect.value.open);

    return (
      <>
        <List
            actions={<ListActions/>}
            sx={{
                "& .RaList-content": {
                    boxShadow: "none",
                    backgroundColor: "transparent",
                },
            }}
        >
            <>
            <CommonFilterCard fields={filterFields} />

            <br />

            <StyledDatagridWrapper title="Cities">
            <Datagrid bulkActionButtons={false} sx={commonDatagridSx}>
                {isCustomSelectOpen && <ResourceSelectDialogButton />}
                <TextField source="id" />
                <TextField source="name" />
                <TextField source="isCurrentlyServing" />
                <FunctionField label="Created At" render={(record: any) => record?.createdAt ? moment(record.createdAt).format('DD MMM YYYY, hh:mm A') : '-'} />
                <FunctionField label="Updated At" render={(record: any) => record?.updatedAt ? moment(record.updatedAt).format('DD MMM YYYY, hh:mm A') : '-'} />
                <ShowButton />
            </Datagrid>
            </StyledDatagridWrapper>
            </>
        </List>
        </>
    );
};
